import { render, staticRenderFns } from "./FilesMigration.vue?vue&type=template&id=4bcade33&"
import script from "./FilesMigration.vue?vue&type=script&lang=js&"
export * from "./FilesMigration.vue?vue&type=script&lang=js&"
import style0 from "./FilesMigration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports